import {
  CoreCrossroadsMapping,
  CrossroadsEntity,
  CrossroadsMapping,
} from '@api/types'
import { ReactNode, createContext, useContext, useState } from 'react'

interface MappingContextType {
  selectedMapping: CrossroadsMapping | null
  setSelectedMapping: (mapping: CrossroadsMapping | null) => void
  selectedChildMapping: CoreCrossroadsMapping | null
  setSelectedChildMapping: (child: CoreCrossroadsMapping | null) => void

  draggedEntity: CrossroadsEntity | null
  setDraggedEntity: (entity: CrossroadsEntity | null) => void
  draggedMapping: CrossroadsMapping | null
  setDraggedMapping: (mapping: CrossroadsMapping | null) => void
}

const MappingContext = createContext<MappingContextType | undefined>(undefined)

export function MappingContextProvider({ children }: { children: ReactNode }) {
  // Store the selected parent and child mapping in state.
  const [selectedMapping, setSelectedMapping] =
    useState<CrossroadsMapping | null>(null)
  const [selectedChildMapping, setSelectedChildMapping] =
    useState<CoreCrossroadsMapping | null>(null)
  const [draggedEntity, setDraggedEntity] = useState<CrossroadsEntity | null>(
    null,
  )
  const [draggedMapping, setDraggedMapping] =
    useState<CrossroadsMapping | null>(null)

  const s = (x: CrossroadsEntity | null) => {
    console.log('setting', x)
    setDraggedEntity(x)
  }

  const value = {
    selectedMapping,
    setSelectedMapping,
    selectedChildMapping,
    setSelectedChildMapping,
    draggedEntity,
    setDraggedEntity: s,
    draggedMapping,
    setDraggedMapping,
  }

  return (
    <MappingContext.Provider value={value}>{children}</MappingContext.Provider>
  )
}

export function useMappingContext() {
  const context = useContext(MappingContext)
  if (!context)
    throw new Error(
      'useMappingContext must be used within a mapping context provider',
    )
  return context!
}
